import { hasClass } from './hasClass.js';
export function addClass(el, str) {
  if (!hasClass(el,  str)) {
    el.className += ' ' + str;
  }
}